module.exports = __webpack_public_path__ + "static/img/pro2-3.619a465.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/pro2-3.png
// module id = GzLg
// module chunks = 0